/** Placeholder for the analytics filter band while saved-filter bootstrap runs. */
export function AnalyticsFilterBandSkeleton() {
  return (
    <div
      className="analytics-filter-band -mx-2 bg-gray-50 border-b border-gray-200"
      aria-hidden
    >
      <div className="flex items-center gap-2 px-3 py-2.5 animate-pulse">
        <div className="h-5 w-24 rounded bg-gray-200" />
        <div className="h-8 w-36 rounded-md bg-gray-200" />
        <div className="h-8 w-28 rounded-md bg-gray-200" />
        <div className="h-8 w-32 rounded-md bg-gray-200" />
        <div className="ml-auto h-8 w-20 rounded-md bg-gray-200" />
      </div>
    </div>
  );
}

export default AnalyticsFilterBandSkeleton;
